import { memo } from "react";
import { SECTION_ELECTIONS } from "../../../../constants/sections";
import { SIDEBAR_WIDGETS } from "../../../../constants/widgets";
import FollowUs from "../../../FollowUs/component";
import ImageLinkWidget from "../../../ImageLinkWidget/component";
import Swimlane from "../../../Swimlane/component";
import { TrendingListNewsLanding } from "../../../TrendingList";
import VerticalCardList from "../../../VerticalCardList/component";
import ListingPolicy from "../../library/ListingPolicy";
import Ad from "../../../Ad/component";
import { getSidebarWidgets } from "../../../../utils/widgets/library";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Heading } from "../../../Heading/component";

export const Sidebar = memo(function Sidebar({ viewport, sidebarWidgets }) {
    const baseSection = useSelector((state) => state.app.baseSection);
    const path = useSelector((state) => state.app.path);
    const rightrail = useSelector((state) => state.rightRail);
    const sectionalContent = useSelector((state) => state.sectionalContent);
    const { contentId } = useParams();
    sidebarWidgets =
        sidebarWidgets ||
        getSidebarWidgets({
            path,
            rightrail,
            viewport,
            baseSection,
            sectionalContent,
            contentId,
        });

    function getOlympicsContentList() {
        const items = sectionalContent;

        if (items && path === `sports/olympics`) {
            const olympicsContent = items[`sports/olympics/promo`];

            if (olympicsContent && olympicsContent.sectionList) {
                return olympicsContent.sectionList;
            }
        }

        return null;
    }

    const olympicsContent = getOlympicsContentList();

    /**
     * Check if there are any widgets to be shown on the sidebar
     * Can be a Regional widget, sports, business etc
     * @return {object} The Component(s) to be rendered
     */
    function getWidgets() {
        if (sidebarWidgets.length) {
            return <div className="widgets">{sidebarWidgets}</div>;
        }
        return null;
    }

    /**
     * Returns the JSX markup for the sidebar swimlane on the election pages (news/canada/montreal/quebecvotes2018, news/canada/new-brunswick/nbvotes2018)
     * @returns {object} The JSX markup to be rendered
     */
    function renderSwimLaneForElection() {
        const customTitleText = `${
            SECTION_ELECTIONS.hasOwnProperty(path)
                ? SECTION_ELECTIONS[path].province
                : ""
        } Votes Features`;
        const customTitleBar = (
            <Heading text={customTitleText} level="h2" levelClassName="h3" />
        );

        const swimlaneProps = {
            section: `${path}/swimlane`,
            className: "electionSideBarSwimlane",
            headline: "",
            customTitleBar: customTitleBar,
            itemCount: 4,
            fetchSection: true,
        };
        return SECTION_ELECTIONS.hasOwnProperty(path) &&
            SECTION_ELECTIONS[path].swimlane ? (
            <Swimlane {...swimlaneProps} />
        ) : null;
    }

    function getBigBox() {
        const mobileHomepage =
            viewport === "viewportSmall" && path === "homepage";

        const plc = viewport === "viewportLarge" ? "right" : "feed";

        return (
            <Ad type="bigbox" targeting={{ plc: plc }} lazy={mobileHomepage} />
        );
    }

    /**
     * Check if there is a Olympics Widget
     * @return {VerticalCardList} The Component to be rendered
     */
    function getOlympicsWidget() {
        if (olympicsContent) {
            return (
                <VerticalCardList
                    items={olympicsContent}
                    title="FEATURED CONTENT"
                    displayPolicy={new ListingPolicy()}
                />
            );
        }
        return null;
    }

    if (path === "homepage") {
        return (
            <div className="sidebar">
                <ImageLinkWidget
                    className="rciWidget"
                    {...SIDEBAR_WIDGETS.radioCanadaInternational}
                />
                {getBigBox()}
                {getOlympicsWidget()}
                {getWidgets()}
                {renderSwimLaneForElection()}
            </div>
        );
    } else if (path === "news") {
        return (
            <div className="sidebar">
                <ImageLinkWidget
                    className="rciWidget"
                    {...SIDEBAR_WIDGETS.radioCanadaInternational}
                />
                {getBigBox()}
                <TrendingListNewsLanding />
                {getWidgets()}
            </div>
        );
    } else {
        return (
            <div className="sidebar">
                <FollowUs path={path} />
                {getBigBox()}
                {getOlympicsWidget()}
                {getWidgets()}
                {renderSwimLaneForElection()}
            </div>
        );
    }
});
